import { requestJson } from './http';

export function getOdooAccounts() {
  return requestJson('/api/odoo-accounts');
}

function query(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      const filtered = value.map(item => String(item || '').trim()).filter(Boolean);
      if (filtered.length) search.set(key, filtered.join(','));
      return;
    }
    if (value !== undefined && value !== null && value !== '') search.set(key, value);
  });
  const suffix = search.toString();
  return suffix ? `?${suffix}` : '';
}

export function getAdvances(params = {}) {
  return requestJson(`/api/advances${query(params)}`);
}

export function getReservationAttachments(recordId) {
  return requestJson(`/api/records/${encodeURIComponent(recordId)}/attachments`);
}

export function getRefunds(params = {}) {
  return requestJson(`/api/refunds${query(params)}`);
}

export function updateAdvanceStatus(payload) {
  return requestJson('/api/advance/status', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function checkAdvanceReference(params = {}) {
  return requestJson(`/api/advance/reference-check${query(params)}`);
}

export function getRecordTimeline(recordId) {
  return requestJson(`/api/records/${encodeURIComponent(recordId)}/timeline`);
}

export function confirmAdvance(payload) {
  return requestJson('/api/advance/confirm', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function updateRefundStatus(payload) {
  return requestJson('/api/refund/status', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function updateRefundBankDetails(payload) {
  return requestJson('/api/refund/bank-details', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}

export function confirmRefund(payload) {
  return requestJson('/api/refund/confirm', {
    method: 'POST',
    body: JSON.stringify(payload)
  });
}
